import tw, { styled } from 'twin.macro';
export const HeaderWrapper = styled.div(({ isModal = true }: { isModal?: boolean }) => [
  tw`flex flex-col items-center gap-1.75 `,
  !isModal && tw`w-full items-start`,
]);
